module.exports = __webpack_public_path__ + "img/content-copy.656f1d83.svg";